var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10389_7034",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 15
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14 0.5H0V14.5H14V0.5Z",
    fill: "#D9D9D9"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10389_7034)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.9987 7.50033C7.31953 7.50033 7.59417 7.38611 7.82266 7.15762C8.05115 6.92913 8.16537 6.65449 8.16537 6.33366C8.16537 6.01283 8.05115 5.73817 7.82266 5.5097C7.59417 5.28123 7.31953 5.16699 6.9987 5.16699C6.67787 5.16699 6.40323 5.28123 6.17474 5.5097C5.94625 5.73817 5.83203 6.01283 5.83203 6.33366C5.83203 6.65449 5.94625 6.92913 6.17474 7.15762C6.40323 7.38611 6.67787 7.50033 6.9987 7.50033ZM6.9987 11.7878C8.18479 10.6989 9.06469 9.7097 9.63828 8.82012C10.2119 7.93053 10.4987 7.14058 10.4987 6.45033C10.4987 5.3906 10.1608 4.52289 9.48516 3.8472C8.80948 3.17151 7.98062 2.83366 6.9987 2.83366C6.01677 2.83366 5.18793 3.17151 4.51224 3.8472C3.83655 4.52289 3.4987 5.3906 3.4987 6.45033C3.4987 7.14058 3.78551 7.93053 4.35911 8.82012C4.93272 9.7097 5.81259 10.6989 6.9987 11.7878ZM6.9987 13.3337C5.43342 12.0017 4.26432 10.7645 3.49141 9.6222C2.71849 8.47986 2.33203 7.42257 2.33203 6.45033C2.33203 4.99199 2.80113 3.83018 3.73932 2.96491C4.67752 2.09963 5.76397 1.66699 6.9987 1.66699C8.23344 1.66699 9.3199 2.09963 10.2581 2.96491C11.1962 3.83018 11.6654 4.99199 11.6654 6.45033C11.6654 7.42257 11.2789 8.47986 10.506 9.6222C9.73307 10.7645 8.56396 12.0017 6.9987 13.3337Z",
    fill: "#344054"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.16f9b49d1d0af88b251150bc618fddc0.svg";
export { ForwardRef as ReactComponent };